import React from 'react';

/**
 * Matches the Atlaskit <ModalFooter showKeyline> API.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.showKeyline - Whether to show the top keyline border.
 * @param {ReactNode} props.children - Child elements.
 * @returns {ReactElement}
 */
const CustomModalFooter = ({ showKeyline, children }) => (
    <div className = { `custom-modal-footer${showKeyline ? ' custom-modal-footer--keyline' : ''}` }>
        {children}
    </div>
);

export default CustomModalFooter;
